import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems, Dialog } from '@headlessui/react'
import React, { useEffect, useState } from 'react';
import {useNavigate} from "react-router-dom";

type UsuariosCapitan = {
    id: number;
    correo:string;
    nombre: string;
    apellido: string;
    cdo: string;
    dto: string;
    area: string;
    puesto: string;
    evidencias_validas: number;
    evidencias_revision: number;
    evidencias_invalidas: number;
    total_evidencias_validas: number;
    total_evidencias_revision: number;
    total_evidencias_invalidas: number;
};

type Evidencia = {
    id: number;
    imagen_path: string;
    calorias_quemadas: number;
    tiempo_ejercicio: number;
    tipo_ejercicio_evidencia: string;
    pasos: number;
    distancia_km: number;
    created_at: string;
    estatus: string;
};

type EvidenciaNueva = {
    archivo: File | null;
    nombreArchivo: string;
    tipo_ejercicio_evidencia: string;
    calorias_quemadas_evidencia: string;
    tiempo_evidencia: string;
    pasos_evidencia: string;
    distancia_evidencia: string;
    correo_evidencia: string;
}

type Evidencia_suma = {
    total_calorias: number;
    total_tiempo: number;
    total_pasos: number;
    total_distancia: number;
};

let usuario = JSON.parse(localStorage.getItem('usuario_data') || '{}');


function PanelViewComponent() {
    // Manejar revisión de evidencia (aprobar/rechazar)
    const manejarRevisionEvidencia = async (evidenciaId: number, nuevoEstatus: string) => {
      try {
        const response = await fetch('https://apis.grupobrame.com/heroes/api/actualizar_estatus_evidencia', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ evidencia_id: evidenciaId, estatus: nuevoEstatus }),
        });
        console.log({ evidencia_id: evidenciaId, estatus: nuevoEstatus });
        const data = await response.json();
        if (data.success) {
          setDetalleEvidencias(prev =>
            prev.map(ev =>
              ev.id === evidenciaId ? { ...ev, estatus: nuevoEstatus } : ev
            )
          );
          window.location.reload(); // Recargar la página al éxito
        } else {
          alert('No se pudo actualizar el estatus.');
        }
      } catch (error) {
        console.error('Error al actualizar estatus:', error);
        alert('Error en la solicitud.');
      }
    };
    const [usuariosCap, setUsuariosCap] = useState<UsuariosCapitan[]>([]);
    const [evidenciasSumas, setEvidenciasSumas] = useState<Evidencia_suma[]>([]);
    const [loading, setLoading] = useState(true);

    const [previewImage, setPreviewImage] = useState<string | null>(null);

    console.log(usuario);

    const [formDataEvidencia, setFormDataEvidencia] = useState<EvidenciaNueva>({
            archivo: null,
            nombreArchivo: '',
            tipo_ejercicio_evidencia:'',
            calorias_quemadas_evidencia:'',
            tiempo_evidencia:'',
            pasos_evidencia:'',
            distancia_evidencia:'',
            correo_evidencia: usuario.correo,
        }
    );
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');
    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const navigate = useNavigate();

    const modalImage = (src: string) => {
        setModalImageSrc(src);
        setIsModalOpen(true);
    };

    /*const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
        const { name, value, type } = e.target;
        const fileList = (e.target as HTMLInputElement).files;

        setFormDataEvidencia(prev => ({
            ...prev,
            [name]: value
        }));
        if (name === "archivo" && fileList && fileList[0]) {
            const file = fileList[0];
            setFormDataEvidencia({ ...formDataEvidencia, [name]: file });
            setPreviewImage(URL.createObjectURL(file));
        } else {
            setFormDataEvidencia({ ...formDataEvidencia, [name]: value });
        }
    };*/
    const cerrarSesion = async () => {
        localStorage.removeItem('usuario_data'); // Borra el usuario guardado
        if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(cacheNames.map(cache => caches.delete(cache)));
        }
        usuario = '{}';
        sessionStorage.clear();
        localStorage.clear();
        window.scrollTo(0, 0);
        navigate('/');
    };

    const miAvance = async () => {
        window.scrollTo(0, 0);
        navigate('/mi_avance');
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type } = e.target;

        if (type === 'file') {
            const file = (e.target as HTMLInputElement).files?.[0] ?? null;

            setFormDataEvidencia(prev => ({
                ...prev,
                [name]: file,
            }));

            // (opcional) Si quieres mostrar vista previa
            if (file) {
                setPreviewImage(URL.createObjectURL(file));
            }
        } else {
            setFormDataEvidencia(prev => ({
                ...prev,
                [name]: value,
            }));
        }
    };
    const [detalleModalOpen, setDetalleModalOpen] = useState(false);
    const [detalleEvidencias, setDetalleEvidencias] = useState<Evidencia[]>([]);

    const revisarIndividual = async (correo: string) => {
        try {
            const response = await fetch('https://apis.grupobrame.com/heroes/api/evidencias', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ correo })
            });

            const data = await response.json();
            if (data.success) {
                setDetalleEvidencias(data.evidencias);
                setDetalleModalOpen(true);
            } else {
                alert('No se encontraron evidencias para este usuario.');
            }
        } catch (error) {
            console.error('Error al obtener evidencias:', error);
            alert('Ocurrió un error al consultar evidencias.');
        }
    };



useEffect(() => {
    const fetchUsuariosCapitan = async () => {
        try {
            const response = await fetch('https://apis.grupobrame.com/heroes/api/usuarios_capitan', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ correo: usuario.correo })
            });

            const data = await response.json();
            console.log("Respuesta completa:", data);
            if (data.success) {
                setUsuariosCap(data.usuarios_capitan);
            }
        } catch (error) {
            console.error("Error al cargar usuarios capitan:", error);
        } finally {
            setLoading(false); // Se asegura que loading sea false después de terminar el fetch
        }
    };

    fetchUsuariosCapitan();
}, []);

    if (loading) {
        return (
            <div className="flex h-screen w-full flex-col items-center justify-center bg-white space-y-4">
                <img
                    src={require('../img/race.gif')}
                    alt="Cargando"
                    className="h-32 w-32"
                />
                <div className="text-center text-lg font-medium text-gray-700 animate-pulse">
                    Cargando...
                </div>
            </div>
        );
    }

    return (
        <div>
            {/*JSON.stringify(usuario, null, 2)*/}
            {/********************************/}
            <div className="min-h-full">
                <Disclosure as="nav" className="border-b border-gray-200 bg-gray-100">
                    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <div className="flex h-16 justify-between">
                            <div className="flex">
                                <div className="flex shrink-0 items-center">
                                    <img
                                        alt="Your Company"
                                        src="https://administraciontigb-grupobrameodoosh1.odoo.com/web/image/website/1/favicon?unique=304a711"
                                        className="block h-8 w-auto lg:hidden"
                                    />
                                    <img
                                        alt="Your Company"
                                        src="https://administraciontigb-grupobrameodoosh1.odoo.com/web/image/website/1/favicon?unique=304a711"
                                        className="hidden h-8 w-auto lg:block"
                                    />
                                </div>

                            </div>
                            <div className="ml-6 flex items-center">
                                {/* Profile dropdown */}
                                <Menu as="div" className="relative ml-3">
                                    <div>
                                        <MenuButton className="relative flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-hidden focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2">
                                            <span className="absolute -inset-1.5" />
                                            <span className="sr-only">Menú Usuario</span>

                                            {usuario.avatar_perfil ? (
                                                <img
                                                    src={'https://apis.grupobrame.com/heroes/'+usuario.avatar_perfil}
                                                    alt="Avatar"
                                                    className="size-8 rounded-full"
                                                />
                                            ) : (
                                                <img
                                                    src="https://apis.grupobrame.com/heroes/img/perfil/default_avatar.jpeg"
                                                    alt="Avatar por defecto"
                                                    className="size-8 rounded-full"
                                                />
                                            )}
                                        </MenuButton>
                                    </div>
                                    <MenuItems
                                        transition
                                        className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
                                    >


                                        {usuario.capitan !== null && (
                                            <MenuItem key="Perfil">
                                                <a
                                                    onClick={miAvance}
                                                    className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden"
                                                >
                                                    Mi Avance
                                                </a>
                                            </MenuItem>
                                        )}
                                        <MenuItem key="Cerrar Sesión">
                                            <a
                                                onClick={cerrarSesion}
                                                className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden"
                                            >
                                                Cerrar Sesión
                                            </a>
                                        </MenuItem>

                                    </MenuItems>
                                </Menu>
                                <div className="ml-3">
                                    <p className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
                                        {usuario.nombre?.charAt(0).toUpperCase() + usuario.nombre?.slice(1)} {usuario.apellido?.charAt(0).toUpperCase() + usuario.apellido?.slice(1)}
                                    </p>
                                    <p className="text-xs font-medium text-gray-500 group-hover:text-gray-700">{usuario.correo}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Disclosure>

                <div className="py-10">
                    <header>
                        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                            <h1 className="text-3xl font-bold tracking-tight text-gray-900">Revisión de Evidencias {usuario.capitan}</h1>
                        </div>
                    </header>
                    <main>

                        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
                            <h3 className="text-base font-semibold text-gray-900"></h3>
                            <dl className="mt-5 grid grid-cols-1 divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-sm md:grid-cols-3 md:divide-x md:divide-y-0">
                                <div className="px-4 py-5 sm:p-6">
                                    <dt className="text-base mb-4 font-normal text-gray-900">Evidencias en Revisión</dt>
                                    <dd className="mt-1 flex items-center justify-center text-center">
                                        <div className="flex items-baseline text-2xl font-semibold text-yellow-600">
                                            {usuariosCap[0]?.total_evidencias_revision ?? 0}
                                            <span className="ml-2 text-sm font-medium text-gray-500"></span>
                                        </div>
                                    </dd>
                                </div>
                                <div className="px-4 py-5 sm:p-6">
                                    <dt className="text-base mb-4 font-normal text-gray-900">Evidencias Validas</dt>
                                    <dd className="mt-1 flex items-center justify-center text-center">
                                        <div className="flex items-baseline text-2xl font-semibold text-green-600">
                                            {usuariosCap[0]?.total_evidencias_validas ?? 0}
                                            <span className="ml-2 text-sm font-medium text-gray-500"></span>
                                        </div>
                                    </dd>
                                </div>
                                <div className="px-4 py-5 sm:p-6">
                                    <dt className="text-base mb-4 font-normal text-gray-900">Evidencias Invalidas</dt>
                                    <dd className="mt-1 flex items-center justify-center text-center">
                                        <div className="flex items-baseline text-2xl font-semibold text-red-600">
                                            {usuariosCap[0]?.total_evidencias_invalidas ?? 0}
                                            <span className="ml-2 text-sm font-medium text-gray-500"></span>
                                        </div>
                                    </dd>
                                </div>
                            </dl>
                        </div>


                        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
                            <ul role="list" className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                                {usuariosCap.map((usr, index) => (
                                    <li key={usr.id}  className="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white text-center shadow-sm">
                                        <div className="flex flex-1 flex-col p-8">
                                            <h2 className="mt-1 text-lg font-medium text-gray-900">
                                                {usr.nombre?.charAt(0).toUpperCase() + usr.nombre?.slice(1)} {usr.apellido?.charAt(0).toUpperCase() + usr.apellido?.slice(1)}
                                            </h2>
                                            <dl className="mt-3 flex grow flex-col justify-between">
                                                <dd className="text-base text-gray-800">{usr.area}</dd>
                                                <dd className="text-base text-gray-500">{usr.puesto}</dd>
                                                <dd className="text-sm text-gray-500 mt-1">{usr.dto === "Ninguno (Personal Administrativo)" ? "Administrativo" : usr.dto}</dd>
                                                <dd className="text-base text-gray-500">{usr.correo}</dd>

                                                <span
                                                    className={
                                                        "mt-4 shrink-0 items-center rounded-full px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset bg-yellow-50 text-yellow-700 ring-yellow-600/20"
                                                    }
                                                >
                                                 {usr.evidencias_revision} En Revisión
                                                </span>
                                                <span
                                                    className={
                                                        "mt-4 shrink-0 items-center rounded-full px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset bg-green-50 text-green-700 ring-green-600/20"
                                                    }
                                                >
                                                 {usr.evidencias_validas} Validas
                                                </span>
                                                <span
                                                    className={
                                                        "mt-4 shrink-0 items-center rounded-full px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset bg-red-50 text-red-700 ring-red-600/20"
                                                    }
                                                >
                                                 {usr.evidencias_invalidas} Invalidas
                                                </span>
                                            </dl>
                                        </div>
                                        <div className="">
                                            <button
                                                onClick={() => revisarIndividual(usr.correo)}
                                                disabled={usr.evidencias_revision === 0}
                                                className={`w-40 m-2 rounded px-4 py-2 text-sm font-medium text-white ${
                                                    usr.evidencias_revision === 0
                                                        ? 'bg-gray-300 cursor-not-allowed'
                                                        : 'bg-orange-400 hover:bg-orange-500'
                                                }`}
                                            >
                                                Revisar Evidencias
                                            </button>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </main>
                </div>
            </div>
            {/********************************/}
            <Dialog open={detalleModalOpen} onClose={() => setDetalleModalOpen(false)} className="fixed inset-0 z-50 bg-black/80  overflow-y-auto">
                <div className="flex m-4 w-full items-center justify-center" onClick={() => setDetalleModalOpen(false)}>
                    <Dialog.Panel
                        className="relative w-full max-w-4xl mx-4 rounded-lg bg-white p-6 shadow-xl"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={() => setDetalleModalOpen(false)}
                            className="absolute top-2 right-2 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-orange-400 text-white text-xl font-bold hover:bg-orange-500"
                            aria-label="Cerrar"
                        >
                            &times;
                        </button>
                        <h2 className="text-2xl font-semibold mb-4 text-center">Evidencias del Usuario</h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                            {detalleEvidencias.map((evidencia, idx) => (
                                <div key={idx} className="bg-gray-50 rounded-lg shadow p-4">
                                    <h3 className="font-bold text-sm mb-2">{evidencia.tipo_ejercicio_evidencia}</h3>
                                    <p className="text-sm text-gray-600">{evidencia.tiempo_ejercicio} min - {evidencia.calorias_quemadas} cal</p>
                                    <p className="text-sm text-gray-600">{evidencia.pasos} pasos - {evidencia.distancia_km} km</p>
                                    <p className="text-xs text-gray-400">{new Date(evidencia.created_at).toLocaleDateString()}</p>
                                    <img src={'https://apis.grupobrame.com/heroes/'+evidencia.imagen_path} alt="evidencia" className="mt-2 rounded-lg object-cover w-full"/>
                                    <span className={
                                        "inline-block mt-2 px-2 py-1 text-xs rounded-full font-medium " +
                                        (evidencia.estatus === "Invalido"
                                            ? "bg-red-100 text-red-800"
                                            : evidencia.estatus === "En Revisión"
                                                ? "bg-yellow-100 text-yellow-800"
                                                : "bg-green-100 text-green-800")
                                    }>
              {evidencia.estatus}
            </span>
                                    {evidencia.estatus === "En Revisión" && (
                                      <div className="mt-3 flex gap-2">
                                        <button
                                          className="flex-1 rounded bg-green-600 px-2 py-1 text-xs font-medium text-white hover:bg-green-700"
                                          onClick={() => manejarRevisionEvidencia(evidencia.id, 'Valido')}
                                        >
                                          Aprobar
                                        </button>
                                        <button
                                          className="flex-1 rounded bg-red-600 px-2 py-1 text-xs font-medium text-white hover:bg-red-700"
                                          onClick={() => manejarRevisionEvidencia(evidencia.id, 'Invalido')}
                                        >
                                          Rechazar
                                        </button>
                                      </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </Dialog.Panel>
                </div>
            </Dialog>
        </div>
    );
}

export default PanelViewComponent;
/**
 * AGRUPAR LAS APROBACIONES Y RECHAZOS EN UN JSON PARA QUE AL SALIR DEL MODAL SE MANDE A ACTUALIZAR TODO DE GOLPE
 *
 * **/